module.exports = __webpack_public_path__ + "static/media/choithramsOrganic.003c32fe.png";